import React from "react";
import styles from "./AccessPrompt.module.css";
import { setCurrentModal } from "../../../redux/actions/modal";
import { useDispatch } from "react-redux";
export default function AccessPrompt({ message }) {
	const dispatch = useDispatch();
	return (
		<div className={styles.accessPrompt}>
			{message === "No valid pass" ? (
				<button onClick={() => dispatch(setCurrentModal("payment"))}>
					PURCHASE ACCESS
				</button>
			) : message === "User not logged in" ? (
				<button onClick={() => dispatch(setCurrentModal("login"))}>
					LOGIN TO ACCESS
				</button>
			) : null}
		</div>
	);
}
